import { useState, useEffect } from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker, Modal, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineEdit, AiOutlineDelete } from 'react-icons/ai';
import toast from 'react-hot-toast';
import axios from 'axios';
import fileDownload from "js-file-download";
import moment from 'moment';
import { useSelector } from 'react-redux';
import ClientMenu from './ClientMenu';
import { DeleteClientService, DownloadClientService, GetClientService } from '../../services/ClientServices';
import { GetCityListService } from '../../services/admin/CityListServices';
import { CgRadioCheck,CgRadioChecked } from "react-icons/cg";
import { MdOutlineCallToAction } from "react-icons/md";
import { GetFileStandardService } from '../../services/admin/FileStandardServices';

function TeacherClassBookingList() {

  const navigator = useNavigate()
  const roles = useSelector(state=>state.Auth.roles)

  const [step, setstep] = useState("FollowUp")

  // let stages = ['FollowUp','Subscribed','FollowUp Expired','Call Not Recieved', 'All Data']
  let stages = ['FollowUp','App Installed', 'Demo Watched','Call Not Recieved','Subscribed','Subscription Expired','Temp Subscribed','All Data']

// FollowUp (3 Days)

  const [modal, setmodal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})
  const [filterOption,setfilterOption] = useState([])


  const [search, setsearch] = useState({ text: '',text1: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false })

  const [cityOptions, setcityOptions] = useState([])
  const [city, setcity] = useState('')

  useEffect(()=>{
    async function loadCities(){
      const response = await GetCityListService()
      const cities = (response?.data?.datas?.[0]?.datas || '').split(',').map((c)=>c.trim()).filter(Boolean)
      setcityOptions(cities?.map((c)=>({label:c,value:c})))
    }
    loadCities()
  },[])

  useEffect(() => {
    getdata()
    getFilterfunc()
  }, [step, page, city])

  async function getdata() {
    const response = await GetClientService(page, search?.text?.value ? search?.text?.data?.match_string : '' ?? '', search?.from_date1, search?.to_date1,step,'',search?.text1,city || '')
    setdata(response?.data)
  }


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetClientService(1, search?.text?.value ? search?.text?.data?.match_string : '' ?? '', search?.from_date1, search?.to_date1,step,'',search?.text1,city || '')
    setdata(response?.data)
  }

  async function resetfilter() {
    setsearch({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,text1:'' })
    setcity('')
    setpage(1)
    const response = await GetClientService(1, '', '', '',step,'','','')
    setdata(response?.data)
  }

    async function getFilterfunc() {
        const response = await GetFileStandardService()
        let arr = []
        response?.data?.datas?.filter((d)=>{
          arr.push({label:d?.standard,value:d?._id,data:d})
        })
        setfilterOption(arr)
      }
  

  async function deleteData() {
    const response = await DeleteClientService(selecteddata?._id)
    if (response?.status === 200) {
      toast.success("Deleted Successfully")
    } else {
      toast.success("Deleted Successfully")
    }
    setmodal(false)
    getdata()
  }

  console.log("search?.text",search?.text)

  async function downloaddata() {
    const response = await DownloadClientService(1, search?.text?.value ? search?.text?.data?.match_string : '' ?? '', search?.from_date1, search?.to_date1, '')
    let path = response.data.path.replace('public/', '')
    handleDownload(`${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`, path.split('/')[path.split('/')?.length - 1])

  }

  const handleDownload = (url, filename) => {
    axios.get(url, {
      responseType: 'blob',
    })
      .then((res) => {
        fileDownload(res.data, filename)
      })
  }


  function openFile(v){
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${v}`
    window.open(url,'_blank')
  }

  const showOption = roles?.filter((f)=>['admin','wfh','executive_team']?.includes(f))?.length > 0

  console.log("filterOption",filterOption)
  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className='md:flex'>
        <div>
          <ClientMenu />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className='flex items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>Total Clients ({data?.pagination?.total})</h6>
            <div className='flex md:hidden items-center text-[12px]'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
            </div>
            </div>

            <div className='flex flex-wrap items-center text-[12px]'>

              <div className='hidden md:flex items-center'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

              <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

              <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />


                <div className='mr-2 w-[130px]'>
                <Select 
                  showSearch
                  filterOption={false}
                  value={search?.text == '' ? null : search?.text}
                  bordered={false}
                  // onSearch={searchemployee}
                  className='border rounded h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
                  options={filterOption}
                  placeholder={<span className="text-[12px] text-gray-300 ">Select Standard</span>}
                  onChange={(e)=>setsearch({...search,text:filterOption.find((f)=>f?.value === e)})}
                  />
              </div>

              <div className='mr-2 w-[130px]'>
                <Select
                  showSearch
                  allowClear
                  filterOption={(input,option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  value={city === '' ? null : city}
                  bordered={false}
                  onChange={(v)=>{setcity(v || '');setpage(1)}}
                  className='border rounded h-[29px] border-slate-300 w-[100%]'
                  options={cityOptions}
                  placeholder={<span className="text-[12px] text-gray-300">Select City</span>}
                  />
              </div>

              <div className='mr-2 mt-1 md:mt-0'>
                <input id="search_text" placeholder='Search text' type='text' value={search.text1} onChange={(e) => setsearch({ ...search, text1: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>
              {/* {(['vehicle_admin','vehicle_creator','admin']?.filter((f)=>roles?.includes(f))?.length > 0 && */}
              <div className='mt-1 md:mt-0'>
              <ButtonFilledAutoWidth btnName="Add New" onClick={() => navigator('create')} />
              </div>
              {/* )} */}
            </div>
          </div>


<div className='flex items-center border-b overflow-x-auto flex-nowrap'>
                {stages?.map((s)=>(
                <h6 onClick={()=>{setstep(s)}} className={`font-[600] ${step === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
                ))}
            </div>


          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>

            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

            <div className='w-[100%] overflow-hidden'>
              {data?.datas?.length > 0 &&
                <>
                {/* Desktop / tablet table */}
                <div className='hidden md:block md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-full  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Client Name</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Email</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Remarks</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Intested  / Subscribed</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[80px] w-[80px]  px-2 py-1 font-[600] text-slate-800 '>Actions</h6>
                  </div>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='flex w-full text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px] px-2 py-1 border-r'>
                        <span className='font-bold'>{d?.name}</span>
                        <div className='flex flex-wrap'>
                        {d?.app_installed && <h6 className='bg-green-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'App Installed'}</h6>}
                        {d?.subscribed && <h6 className='bg-yellow-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Subscribed'}</h6>}
                        {d?.temp_subscribed && <h6 className='bg-violet-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Temp Subscribed'}</h6>}
                        {d?.demo_call_completed && <h6 className='bg-red-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Demo Watched'}</h6>}
                        </div>

                        {(d?.standard?.label || d?.standard?.name || d?.stream?.name || d?.sub_stream?.name) &&
                        <div className='mt-1 border border-slate-200 rounded text-[10px]'>
                          {d?.standard?.label && <div className='flex border-b border-slate-200'>
                            <span className='w-[80px] shrink-0 bg-slate-100 px-1 py-[2px] font-[600] border-r border-slate-200'>Standard</span>
                            <span className='px-1 py-[2px] truncate'>{d?.standard?.label}</span>
                          </div>}
                          {d?.section_board?.name && <div className='flex border-b border-slate-200'>
                            <span className='w-[80px] shrink-0 bg-slate-100 px-1 py-[2px] font-[600] border-r border-slate-200'>Board</span>
                            <span className='px-1 py-[2px] truncate'>{d?.section_board?.name}</span>
                          </div>}
                          {d?.stream?.name && <div className='flex border-b border-slate-200'>
                            <span className='w-[80px] shrink-0 bg-slate-100 px-1 py-[2px] font-[600] border-r border-slate-200'>Stream</span>
                            <span className='px-1 py-[2px] truncate'>{d?.stream?.name}</span>
                          </div>}
                          {d?.sub_stream?.name && <div className='flex'>
                            <span className='w-[80px] shrink-0 bg-slate-100 px-1 py-[2px] font-[600] border-r border-slate-200'>Sub Stream</span>
                            <span className='px-1 py-[2px] truncate'>{d?.sub_stream?.name}</span>
                          </div>}
                        </div>}

                      </h6>
                      <h6 className=' text-[12px] break-word min-w-[160px] w-[160px] px-2 py-1 font-[500] border-r'>
                        <span className='font-bold'>{d?.mobile}</span><br></br>
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                       {d?.email}
                      </h6>
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  px-2 py-1  border-r'>
                        {d?.remarks}
                      </h6>
                      <h6 className='flex   break-word  min-w-[180px] w-[180px]  px-2 py-1 font-[500] border-r'>{!d?.interested ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />} <span className='mx-2 text-slate-300'>/</span>  {!d?.subscribed ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}  </h6>
                      <h6 className='  break-word min-w-[120px] w-[120px]  px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LL')}</h6>
                      <h6 className='flex items-start  min-w-[80px] w-[80px]  px-2 py-1 font-[500] '>
                        <AiOutlineEdit onClick={() => navigator('edit', { state: d })} className='mr-2' />
                        {showOption && <MdOutlineCallToAction onClick={() => navigator('call_to_customer', { state: d })} className='mr-2' />}
                        {roles.includes('admin')  && <AiOutlineDelete onClick={() => { setselecteddata(d); setmodal(true) }} />}
                      </h6>
                    </div>))}
                </div>

                {/* Mobile card list */}
                <div className='md:hidden mt-3 space-y-2'>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                      <div className='flex items-start justify-between'>
                        <div>
                          <h6 className='text-[13px] font-[700]'>{d?.name}</h6>
                          <h6 className='text-[11px] text-slate-600'>{d?.mobile}</h6>
                        </div>
                        <div className='flex items-center -mr-1.5'>
                          <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={() => navigator('edit', { state: d })} /></span>
                          {showOption && <span className='p-2 cursor-pointer'><MdOutlineCallToAction size={17} onClick={() => navigator('call_to_customer', { state: d })} /></span>}
                          {roles.includes('admin') && <span className='p-2 cursor-pointer'><AiOutlineDelete size={17} onClick={() => { setselecteddata(d); setmodal(true) }} /></span>}
                        </div>
                      </div>

                      {d?.email && <h6 className='text-[11px] mt-1 break-all'>{d?.email}</h6>}

                      <div className='flex flex-wrap mt-1.5'>
                        {d?.app_installed && <h6 className='bg-green-200 px-1.5 py-1 text-[10px] font-[600] rounded m-[2px]'>App Installed</h6>}
                        {d?.subscribed && <h6 className='bg-yellow-200 px-1.5 py-1 text-[10px] font-[600] rounded m-[2px]'>Subscribed</h6>}
                        {d?.temp_subscribed && <h6 className='bg-violet-200 px-1.5 py-1 text-[10px] font-[600] rounded m-[2px]'>Temp Subscribed</h6>}
                        {d?.demo_call_completed && <h6 className='bg-red-200 px-1.5 py-1 text-[10px] font-[600] rounded m-[2px]'>Demo Watched</h6>}
                      </div>

                      {(d?.standard?.label || d?.stream?.name || d?.sub_stream?.name) &&
                      <div className='mt-1 border border-slate-200 rounded text-[11px]'>
                        {d?.standard?.label && <div className='flex border-b border-slate-200'>
                          <span className='w-[90px] shrink-0 bg-slate-100 px-1.5 py-1 font-[600] border-r border-slate-200'>Standard</span>
                          <span className='px-1.5 py-1'>{d?.standard?.label}</span>
                        </div>}
                        {d?.section_board?.name && <div className='flex border-b border-slate-200'>
                          <span className='w-[90px] shrink-0 bg-slate-100 px-1.5 py-1 font-[600] border-r border-slate-200'>Board</span>
                          <span className='px-1.5 py-1'>{d?.section_board?.name}</span>
                        </div>}
                        {d?.stream?.name && <div className='flex border-b border-slate-200'>
                          <span className='w-[90px] shrink-0 bg-slate-100 px-1.5 py-1 font-[600] border-r border-slate-200'>Stream</span>
                          <span className='px-1.5 py-1'>{d?.stream?.name}</span>
                        </div>}
                        {d?.sub_stream?.name && <div className='flex'>
                          <span className='w-[90px] shrink-0 bg-slate-100 px-1.5 py-1 font-[600] border-r border-slate-200'>Sub Stream</span>
                          <span className='px-1.5 py-1'>{d?.sub_stream?.name}</span>
                        </div>}
                      </div>}

                      {d?.remarks && <h6 className='text-[11px] mt-2'><span className='font-[600]'>Remarks:</span> {d?.remarks}</h6>}

                      <div className='flex items-center mt-2 text-[11px]'>
                        <span className='font-[600] mr-1'>Interested</span>{!d?.interested ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}
                        <span className='mx-2 text-slate-300'>/</span>
                        <span className='font-[600] mr-1'>Subscribed</span>{!d?.subscribed ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}
                      </div>

                      <h6 className='text-[10px] text-slate-400 mt-2'>Created {moment(d?.createdAt)?.format('LL')}</h6>
                    </div>
                  ))}
                </div>
                </>}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default TeacherClassBookingList